<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M10,2C9.54,2,9.15,2.31,9.04,2.73C9.04,2.73,6.05,12.69,6.05,12.69C6.02,12.79,6,12.89,6,13C6,13.55,6.45,14,7,14C7.46,14,7.85,13.69,7.96,13.27C7.96,13.27,10.95,3.31,10.95,3.31C10.98,3.21,11,3.1100000000000003,11,3C11,2.45,10.55,2,10,2C10,2,10,2,10,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Slash',
} as DefineComponent
</script>
